import { useEffect, useState } from "react";
import queryString from 'query-string';
import history from "../../history";
import moment from "moment";
import { Table, Card, Row, Col, Drawer, message, Modal, Spin, Form, Input, InputNumber, Select, Space, Button, Tooltip as TooltipAnd } from 'antd';
import ruhsatSoruCevapGuncelle from "../../services/ruhsatSoruCevapGuncelle";
import getRuhsatSoruCevapList from "../../services/ruhsatSoruCevapList";
import gonderimDurumu from "../../hooks/gonderimDurum";
const { Option } = Select;

const parsed = queryString.parse(history.location.search);

message.config({
  top: '50%',
});

function onChange(e, key, record) {
  record[key] = e.target.value;
  console.log('changed', e.target.value);
}

const RuhsatSoruCevapForm = () => {
  const [spining, setSpining] = useState(true);
  const [visible, setVisible] = useState(false);
  const [ruhsatSoruCevapList, setRuhsatSoruCevapList] = useState([]);
  const basvuruId = parseInt(parsed.basvuruId);
  const relAllRecord = parsed.relAllRecord ? parsed.relAllRecord == 'true' : false;
  const originData = [];
  const [dates, setDates] = useState([moment(), moment()]);
  const [queryDates, setQueryDates] = useState([undefined, undefined]);
  const { gonderimDurumuEnum } = gonderimDurumu();

  const onLoad = async () => {
    await getRuhsatSoruCevapList(basvuruId,relAllRecord).then(res => {
      setRuhsatSoruCevapList(res.data.result);
    });
    setVisible(true);
    setSpining(false);
    setQueryDates(dates);
  }
  useEffect(() => {
    onLoad();
  }, []);


  const columns = [
    {
      title: 'Sıra',
      dataIndex: 'ruhsatSoruId',
      width: '10%',
      editable: false,
    },
    {
      title: 'Soru',
      dataIndex: 'soru',
      width: '40%',
      editable: false,
    },
    {
      title: 'Cevap',
      dataIndex: 'cevap',
      width: '50%',
      key: 'cevap',
      render: (text, record, value) => (
        <div>
          <Input
            defaultValue={record.cevap}
            onChange={e => onChange(e, 'cevap', record)}
            maxLength={500}
          />
        </div>
      )
    }
  ];

  const reloadLoc = () => {
    window.parent.location.reload();
  }

  const success = (text) => {
    message.success(text);
  };

  const error = (text) => {
    message.error(text);
  };

  const ruhsatSoruCevapKaydet = () => {
    setSpining(true);
    var selectedRows = ruhsatSoruCevapList;
    var requestModel = {};
    if (selectedRows.length > 0) {
      requestModel.BasvuruId = basvuruId;
      requestModel.ebRuhsatSoruCevapRequestList = [];
      for (var i = 0; i < selectedRows.length; i++) {
        requestModel.ebRuhsatSoruCevapRequestList.push({
          "objectId": selectedRows[i].objectid,
          "cevap": selectedRows[i].cevap
        });
      }
      //TODO Metod çağrılacak
      var resultval = false;
      ruhsatSoruCevapGuncelle(requestModel)
        .then(res => { res.data.success ? success('İşlem başarı ile tamamlandı.') : error(res.data.message); setSpining(false); })
        .catch(ex => {
          setSpining(false);
        })
      //window.parent.location.reload();
    } else {
      setSpining(false);
    }

  }


  return <Spin tip={"Veriler Yükleniyor"} spinning={spining} >
    <Card bodyStyle={{ padding: "10" }}
    //style={{ margin: "20px" }}
    //title={<h4 style={{ fontWeight: "bolder", color: "white" }}>Harç Bilgileri Formu</h4>}
    //</Spin>className="ant-card-head-title-large"
    >
      <Row gutter={16}>
        <Col span={18}>
          {visible &&
            <Table scroll={{}} rowKey={"objectid"} dataSource={ruhsatSoruCevapList}
              columns={columns}
              title={() => <div style={{ display: "flex", justifyContent: "space-between" }}><h3 style={{ fontWeight: "bolder" }}>{''}</h3></div>}
              pagination={false}
              onChange={
                (filters, sorter, extra) => {
                  if (extra.currentDataSource.length < originData.length) {
                  }
                  else {
                  }
                }
              }
            />
          }
        </Col>
        <Col span={6} style={{ display: 'flex', alignItems: 'flex-end' }}>
          <Button
            onClick={ruhsatSoruCevapKaydet}
            type="primary"
            style={{
              marginTop: 5
            }}
            loading={spining}
          >
            Kaydet
          </Button>
        </Col>
      </Row>
    </Card>
  </Spin>

}
export default RuhsatSoruCevapForm;